module.exports = __webpack_public_path__ + "static/media/logo_black.df3387dc.svg";